// Apple-style Contact Page Animations

class ContactAnimations {
  constructor() {
    this.section = null;
    this.isMobile = this.checkMobile();
    this.init();
  }

  checkMobile() {
    return window.innerWidth <= 749;
  }

  init() {
    this.section = document.querySelector('.contact-custom');
    if (!this.section) return;

    // On mobile, simpler animations
    if (this.isMobile) {
      this.initMobileAnimations();
      return;
    }

    // Wait for GSAP and ScrollTrigger
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(() => this.init(), 50);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Initialize animations
    this.animateHeader();
    this.animateInfoCards();
    this.animateForm();
  }

  initMobileAnimations() {
    const elements = [
      this.section.querySelector('.contact-custom__header'),
      ...this.section.querySelectorAll('.contact-info-card'),
      this.section.querySelector('.contact-custom__form-wrapper'),
    ];

    elements.forEach(el => {
      if (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      }
    });
  }

  animateHeader() {
    const header = this.section.querySelector('.contact-custom__header');
    if (!header) return;

    gsap.to(header, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: header,
        start: 'top 85%',
        toggleActions: 'play none none reverse',
      },
    });
  }

  animateInfoCards() {
    const cards = this.section.querySelectorAll('.contact-info-card');
    if (cards.length === 0) return;

    cards.forEach((card, index) => {
      gsap.to(card, {
        opacity: 1,
        x: 0,
        duration: 0.8,
        delay: index * 0.15,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
      });

      // Hover animation
      const icon = card.querySelector('.contact-info-card__icon');
      if (icon) {
        card.addEventListener('mouseenter', () => {
          gsap.to(icon, {
            scale: 1.1,
            rotation: 5,
            duration: 0.3,
            ease: 'back.out(1.7)',
          });
        });

        card.addEventListener('mouseleave', () => {
          gsap.to(icon, {
            scale: 1,
            rotation: 0,
            duration: 0.3,
            ease: 'power2.out',
          });
        });
      }
    });
  }

  animateForm() {
    const formWrapper = this.section.querySelector('.contact-custom__form-wrapper');
    if (!formWrapper) return;

    gsap.to(formWrapper, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: formWrapper,
        start: 'top 80%',
        toggleActions: 'play none none reverse',
      },
    });

    // Animate form fields with stagger
    const fields = formWrapper.querySelectorAll('.contact-custom__form-field');
    fields.forEach((field, index) => {
      gsap.fromTo(field,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          delay: 0.2 + (index * 0.1),
          ease: 'power2.out',
          scrollTrigger: {
            trigger: formWrapper,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      );
    });

    // Button animation
    const button = formWrapper.querySelector('.contact-custom__button');
    if (button) {
      gsap.fromTo(button,
        { opacity: 0, scale: 0.9 },
        {
          opacity: 1,
          scale: 1,
          duration: 0.6,
          delay: 0.5,
          ease: 'back.out(1.7)',
          scrollTrigger: {
            trigger: formWrapper,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      );
    }
  }
}

// Initialize
function waitForGSAP(callback, maxAttempts = 50) {
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    callback();
  } else if (maxAttempts > 0) {
    setTimeout(() => waitForGSAP(callback, maxAttempts - 1), 100);
  }
}

function initContactAnimations() {
  const contactSection = document.querySelector('.contact-custom');
  if (contactSection) {
    new ContactAnimations();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    waitForGSAP(initContactAnimations);
  });
} else {
  waitForGSAP(initContactAnimations);
}

